import { useTranslation } from "react-i18next";
import { BotsChooser } from "../BotsChooser";
import { useSearchContext } from "../../contexts";
import { DropdownFilter } from "../../../../components/Filters/DropdownFilter";

interface BotsChooserDropdownProps {
  onOpenChange?: (isOpen: boolean) => void;
}

export const BotsChooserDropdown: React.FC<BotsChooserDropdownProps> = ({ onOpenChange }) => {
  const { state } = useSearchContext();
  const { t } = useTranslation();

  // Mutual exclusivity logic for filters
  const getActiveExclusiveFilter = (): string | null => {
    if (state.draftFilters.sourceGroups.value.length > 0) return 'Actor groups';
    if (state.draftFilters.affiliations.value.length > 0) return 'State-affiliated';
    if (state.draftFilters.discreditations.value.length > 0) return 'High risk accounts';
    if (state.draftFilters.bots.value === true && state.draftFilters.bots.exclude === false) return 'Show only inauthentic actors';
    return null;
  };

  const activeExclusiveFilter = getActiveExclusiveFilter();

  const isFilterDisabled = (filterName: string): boolean => {
    return !!(activeExclusiveFilter && activeExclusiveFilter !== filterName);
  };

  const getDisabledTooltip = (filterName: string): string | undefined => {
    if (!isFilterDisabled(filterName) || !activeExclusiveFilter) return undefined;
    return t(`This filter can't be combined with '{{activeFilter}}'`, { activeFilter: t(activeExclusiveFilter) });
  };

  return (
    <DropdownFilter
      title={t("Inauthentic behavior")}
      counter={
        state.draftFilters.bots.value === null
          ? 0
          : 1
      }
      isExclude ={state.draftFilters.bots.exclude}
      onOpenChange={onOpenChange}
    >
      <BotsChooser
        disableShowOnly={isFilterDisabled('Show only inauthentic actors')}
        disabledTooltip={getDisabledTooltip('Show only inauthentic actors')}
      />
    </DropdownFilter>
  )
};
